/** Must match backend `workgroups-file-policy.ts` default (75 MiB). */
export const MAX_WORKGROUPS_UPLOAD_BYTES = 78643200;

export const WORKGROUPS_UPLOAD_MSG_TOO_LARGE =
  'File is too large. Maximum upload size is 75 MB.';

export function validateWorkgroupsUploadFileClient(file: File): string | null {
  if (file.size > MAX_WORKGROUPS_UPLOAD_BYTES) {
    return WORKGROUPS_UPLOAD_MSG_TOO_LARGE;
  }
  return null;
}
